import React from 'react'


const ViewDocs = ({abortCallBack=()=>{}, onLoadCallBack=()=>{}, docSrc='', useframe=false}) => {
  const ext = docSrc.split('.').reverse()[0]

  return (
    <>
        {ext !== 'pdf' && <>
          {!useframe && <img className="_img" alt="Failed to load" onAbort={abortCallBack} onLoad={onLoadCallBack} src={docSrc} />}

          {useframe && <>
              {docSrc !== "-" ?         
                  <iframe width="100%" height="300px" style={{ objectFit: "fill" }} onAbort={abortCallBack} onLoad={onLoadCallBack} src={docSrc}></iframe>
                  : "No document"
              }
          </>}
        </>}

        {ext === 'pdf' &&<div>
        <iframe width="100%" height="300px" style={{ objectFit: "fill" }} onAbort={abortCallBack} onLoad={onLoadCallBack} src={docSrc}>
        </iframe>

        </div>}
    </>
    
  )
}

export default ViewDocs